import {createSlice} from "@reduxjs/toolkit";

const initialInscripcion = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    inscripcion: undefined,
    lastError: null
  };

  export const callTypes = {
    list: "list",
    action: "action"
  };

  export const inscripcionSlice=createSlice({
      name:"aspirante",
      initialState:initialInscripcion,
      reducers:{
        catchError:(state,action)=>{
            state.error = action.payload.error.clientMessage;
            if(action.payload.callType===callTypes.list){
                state.listLoading=false;
            }else{
                state.actionsLoading=false;
            };
        },
        starCall:(state,action)=>{
            state.error=null;
            if(action.payload.callType===callTypes.list){
                state.listLoading=true;
            }else{
                state.actionsLoading=true;
            };
        },
        // createInscripcion
        inscripcionCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.entities.push(action.payload.inscripcion);
        },
        inscripcionFetched: (state, action) => {
            state.actionsLoading = false;
            state.inscripcion = action.payload.inscripcion;
            state.error = null;
        },
        // findInscripciones
        inscripcionesFetched: (state, action) => {
            const { inscripciones } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = inscripciones;
            state.totalCount = inscripciones && inscripciones.length;
        },
        // deleteInscripcion
        inscripcionDeleted: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.entities = state.entities.filter(el => el.inscripcionId !== action.payload.inscripcionId);
        },
      }
  });